import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import http from '../config/http-service';

export interface IDedDetailsStats {
  total: number;
  active: number;
  inactive: number;
  withContact: number;
  withoutContact: number;
  activeRate: string;
  contactAvailabilityRate: string;
  message: string;
}

const endpoint = 'ums/v1/crm/management/ded/licenses/stats/overview';
export const getDedDetailsStatsEndpointIdentifier = endpoint;

type TData = IDedDetailsStats;
type TError = AxiosError;
type TQueryKey = [typeof endpoint];

type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetDedDetailsStatsApi(options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();
  const queryKey: TQueryKey = [endpoint];

  const queryFn = async (): Promise<TData> => {
    const { data } = await http.get(endpoint);
    return data;
  };

  return useQueryWrapper(queryKey, queryFn, {
    enabled: isLoggedIn,
    ...options,
  });
}
